import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import Apps from '@mui/icons-material/Apps';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

export default function ViewOptions({ selectedOption, handleSetView }) {
  const handleClick = (event, viewOption) => {
    handleSetView(viewOption);
  };

  return (
    <ToggleButtonGroup
      exclusive
      variant="store"
      size="small"
      value={selectedOption}
      onChange={handleClick}
      aria-label="view"
    >
      <ToggleButton
        variant="store"
        type="button"
        color="grey"
        value="grid"
        disabled={selectedOption === 'grid'}
        data-core-qa="storeViewOptionsButton"
        aria-label="grid"
        fullWidth
      >
        <Apps fontSize="small" />
      </ToggleButton>
      <ToggleButton
        variant="store"
        type="button"
        color="grey"
        value="list"
        onClick={() => handleClick('list')}
        disabled={selectedOption === 'list'}
        data-core-qa="storeViewOptionsButton"
        aria-label="list"
        fullWidth
      >
        <FormatListBulletedIcon fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
